import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
// -- component --
import { CompCardsComponent } from '../comp-cards/comp-cards.component';
import { CardType4Component } from '../../../components/card-type-4/card-type-4.component';

interface CapacityCard {
    formid: number;
    imagemobile: string;
    imagedesktop: string;
    imagetablet: string;
    switchergroup: string;
    institution: string;
    cta: string;
    id: number;
    description: string;
    title: string;
    publishdate: string;
    url: string;
    formalias: string;
    category?: string;
}

interface CardGroup {
    title: string;
    childElements: CapacityCard[];
}

@Component({
    selector: 'app-step-1',
    standalone: true,
    imports: [
        CompCardsComponent,
        CommonModule,
        MatIconModule,
        CardType4Component,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './step-1.component.html',
    styleUrls: ['./step-1.component.scss'],
})
export class Step1Component implements OnInit, OnChanges {
    @Input() trainingCards: CapacityCard[] = [];

    cards: CardGroup[] = [];
    visibleCountPerColumn: number = 4; // Show 2 items per column initially
    increment: number = 4; // Add 2 more items per column
    isMobile: boolean = window.innerWidth < 768;
    gaPrefix = 'training_programmes_learn_more_';

    ngOnInit() {
        if (this.isMobile) {
            this.visibleCountPerColumn = 3;
        } else {
            this.visibleCountPerColumn = 4;
        }

        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 768;

            if (this.isMobile) {
                this.visibleCountPerColumn = 3;
            } else {
                this.visibleCountPerColumn = 4;
            }
        });
    }

    // TrackBy functions to prevent unnecessary re-renders
    trackByColumn(index: number, column: CardGroup): string {
        return column.title;
    }

    trackByCard(index: number, card: CapacityCard): number {
        return card.id;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['trainingCards'] && this.trainingCards) {
            this.processCards();
        }
    }

    private processCards(): void {
        // Group cards by category
        const ALLOWED_CATEGORIES = ['general', 'theme-specific'];
        const headings = {
            general: 'Foundation Programme General',
            ['theme-specific']: 'Foundation Programme (Theme Specific)',
        };
        const groupedCards = [];
        this.trainingCards.map((card) => {
            if (ALLOWED_CATEGORIES.includes(card.category)) {
                const category = headings[card.category];

                if (!groupedCards[category]) {
                    groupedCards[category] = [];
                }
                groupedCards[category].push(card);
            }
        }, {} as Record<string, CapacityCard[]>);

        // Convert to array format expected by template
        this.cards = Object.keys(groupedCards)
            .map((category) => ({
                title: category,
                childElements: groupedCards[category],
            }))
            .sort((a, b) => b.title.localeCompare(a.title));
    }

    showMore(): void {
        this.visibleCountPerColumn += this.increment;
    }

    shouldShowMoreButton(): boolean {
        return this.cards.some(
            (column) => column.childElements.length > this.visibleCountPerColumn
        );
    }

    openLink(url: string): void {
        if (url && url.trim()) {
            // Ensure URL has protocol
            let finalUrl = url.trim();
            if (
                !finalUrl.startsWith('http://') &&
                !finalUrl.startsWith('https://')
            ) {
                finalUrl = 'https://' + finalUrl;
            }
            window.open(finalUrl, '_blank', 'noopener,noreferrer');
        }
    }
}
